exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-menu,.tooltip-profile{font-size:15px;z-index:60}.tooltip-profile{margin-top:30px!important;margin-left:-45px!important}.tooltip-menu .tooltip-arrow{display:none}.home.open>.tooltip-menu,.home.open>.tooltip-profile{display:none!important;visibility:hidden!important;opacity:0!important}@media (max-width:420px){.tooltip-menu,.tooltip-profile{display:none!important;visibility:hidden!important;opacity:0!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43adba76","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/core/Sidebar.vue
// module id = 899
// module chunks = 2